import { useEffect, useState } from "react";
import SelectionComponent from "./Component/SelectionComponent";
import TextComponent from "./Component/TextComponent";
import DateComponent from "./Component/DateComponent";
import NumberComponent from "./Component/NumberComponent";
import DecimalComponent from "./Component/DecimalComponent";
import MultiSelectionComponent from "./Component/MultiSelectionComponent";
import { Box, CircularProgress, Container } from "@mui/material";
import { useShareContext } from "./BasvuruContext";
import KriterModulBilesenservice from "../../../service/Ebasvuru/AdayDomain/KriterModulBilesenService";
import KriterGroupItem from "./KriterGroupItem";
import { HeaderText } from "../../../menu/muiStyles";

const KriterModulBilesenlerComponent = ({ modulId, kriterKomponent, setKomponentKriterler, moduleName }) => {
    const [kriterler, setKriterler] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selKriterler, setSelKriterler] = useState({});

    const { updateSelKriterler, modulKriterler } = useShareContext();



    /// script to reated the bilesne item for komponent
    useEffect(() => {

        setLoading(true);
        if (modulId) {
            KriterModulBilesenservice.fullGet({
                filter: { modulId, kriterKomponentId: kriterKomponent, aktif: true },
                order: [
                    { key: "siralama", value: "asc" },
                ]
            }).then((res) => {
                setLoading(false);
                if (res && res.isSuccess) {
                    setKriterler(res.resultObject);
                }
            });
        }
    }, [modulId]);

    /// read selection data from context for this moudel
    useEffect(() => {

        if (!selKriterler || kriterKomponent) return;

        ;
        const data = modulKriterler.find(itm => Number(itm.modulId) === Number(modulId))?.kriterler || {};
        setSelKriterler(data);
    }, []);


    /// this script control changes in kriterler, where 
    useEffect(() => {
        setSelKriterler((prev) => {
            let updatedSelections = { ...prev };

            kriterler.forEach((kriter) => {
                if (kriter.kriterModul.anneKriterId && !(kriter.kriterModul.anneKriterId in prev)) {
                    updatedSelections[kriter.kriterModul.id] = ""; // Reset dependent selection
                }
            });

            return JSON.stringify(updatedSelections) === JSON.stringify(prev) ? prev : updatedSelections;
        });
    }, [kriterler]); // ✅ Removed selKriterler from dependencies


    /// this script check change in selKriterler running effect to update
    useEffect(() => {
        if (!kriterKomponent) {
            updateSelKriterler({
                modulId: modulId,
                kriterKomponent: kriterKomponent,
                kriterler: selKriterler
            });
        } else {

            /*  console.log("Komponent");
              console.log(selKriterler);
  */
            setKomponentKriterler(selKriterler);
        }
    }, [selKriterler]);




    const handleSelectionChange = (kriterId, value, text, kriterGrupAdi, isGroup) => {
        setSelKriterler((prev) => {

            // Clone previous selections
            let updatedSelections = { ...prev };

            // Function to recursively find and clear all child kriter values
            const clearChildSelections = (parentId) => {
                kriterler.forEach((kriter) => {
                    if (kriter.kriterModul.bagliOlunanKriterId === parentId) {
                        delete updatedSelections[kriter.kriterModul.id]; // Remove selection
                        clearChildSelections(kriter.kriterModul.id); // Recursively clear child nodes
                    }
                });
            };

            // If value is null or undefined, delete the selection
            if (value === null || value === undefined) {
                delete updatedSelections[kriterId];
            } else {
                updatedSelections[kriterId] = { value, text, kriterGrupAdi, isGroup };
            }

            // Clear dependent selections when parent changes
            kriterler.forEach((kriter) => {
                if (kriter.kriterModul.anneKriterId === kriterId) {
                    // You can delete or reset the dependent keys, depending on your logic.
                    // I assume you want to delete them as well:
                    delete updatedSelections[kriter.kriterModul.id];
                }
            });

            // Clear all children of the changed kriter
            clearChildSelections(kriterId);

            return updatedSelections;
        });
    };


    if (loading) return <div style={{ textAlign: "center" }}><CircularProgress color="success" /></div>;

    const renderComponent = (kriter) => {
        switch (kriter.kriterModul.valueType) {
            case 1:
                return (
                    <SelectionComponent
                        key={kriter.kriterModul.id}
                        kriterId={kriter.kriterModul.id}
                        kriterAdi={kriter.kriterModul.display}
                        parentKriterId={kriter.kriterModul.anneKriterId}
                        bagliOlunanKriterId={kriter.kriterModul.bagliOlunanKriterId}
                        bagliOlunanKriterSecenekId={kriter.kriterModul.bagliOlunanKriterSecenekId}
                        parentSecenekId={selKriterler[kriter.kriterModul.anneKriterId]?.value}
                        selKriterler={selKriterler}
                        zorunlu={kriter.zorunlu}
                        onChange={handleSelectionChange}
                    />
                );
            case 2:
                return <TextComponent
                    key={kriter.kriterModul.id}
                    kriterId={kriter.kriterModul.id}
                    kriterAdi={kriter.kriterModul.display}
                    parentKriterId={kriter.kriterModul.anneKriterId}
                    bagliOlunanKriterId={kriter.kriterModul.bagliOlunanKriterId}
                    bagliOlunanKriterSecenekId={kriter.kriterModul.bagliOlunanKriterSecenekId}
                    parentSecenekId={selKriterler[kriter.kriterModul.anneKriterId]?.value}
                    selKriterler={selKriterler}  // Pass selected values
                    zorunlu={kriter.zorunlu}
                    onChange={handleSelectionChange}
                />
            case 3:
                return (
                    <MultiSelectionComponent
                        key={kriter.kriterModul.id}
                        kriterId={kriter.kriterModul.id}
                        kriterAdi={kriter.kriterModul.display}
                        parentKriterId={kriter.kriterModul.anneKriterId}
                        bagliOlunanKriterId={kriter.kriterModul.bagliOlunanKriterId}
                        bagliOlunanKriterSecenekId={kriter.kriterModul.bagliOlunanKriterSecenekId}
                        parentSecenekId={selKriterler[kriter.kriterModul.anneKriterId]?.value}
                        selKriterler={selKriterler}  // Pass selected values
                        zorunlu={kriter.zorunlu}
                        onChange={handleSelectionChange}
                    />
                );
            case 4:
                return <NumberComponent
                    key={kriter.kriterModul.id}
                    kriterId={kriter.kriterModul.id}
                    kriterAdi={kriter.kriterModul.display}
                    bagliOlunanKriterId={kriter.kriterModul.bagliOlunanKriterId}
                    bagliOlunanKriterSecenekId={kriter.kriterModul.bagliOlunanKriterSecenekId}
                    parentKriterId={kriter.kriterModul.anneKriterId}
                    parentSecenekId={selKriterler[kriter.kriterModul.anneKriterId]?.value}
                    selKriterler={selKriterler}  // Pass selected values
                    zorunlu={kriter.zorunlu}
                    onChange={handleSelectionChange}
                />
            case 5:
                return <DateComponent
                    key={kriter.kriterModul.id}
                    kriterId={kriter.kriterModul.id}
                    kriterAdi={kriter.kriterModul.display}
                    bagliOlunanKriterId={kriter.kriterModul.bagliOlunanKriterId}
                    bagliOlunanKriterSecenekId={kriter.kriterModul.bagliOlunanKriterSecenekId}
                    parentKriterId={kriter.kriterModul.anneKriterId}
                    parentSecenekId={selKriterler[kriter.kriterModul.anneKriterId]?.value}
                    selKriterler={selKriterler}  // Pass selected values
                    zorunlu={kriter.zorunlu}
                    onChange={handleSelectionChange}
                />
            case 6:
                return <DecimalComponent
                    key={kriter.kriterModul.id}
                    kriterId={kriter.kriterModul.id}
                    kriterAdi={kriter.kriterModul.display}
                    bagliOlunanKriterId={kriter.kriterModul.bagliOlunanKriterId}
                    bagliOlunanKriterSecenekId={kriter.kriterModul.bagliOlunanKriterSecenekId}
                    parentKriterId={kriter.kriterModul.anneKriterId}
                    parentSecenekId={selKriterler[kriter.kriterModul.anneKriterId]?.value}
                    selKriterler={selKriterler}  // Pass selected values
                    zorunlu={kriter.zorunlu}
                    onChange={handleSelectionChange}
                />
        }

        if (kriter.kriterGrubuId) {
            return <KriterGroupItem
                key={kriter.kriterModul.id}
                kriter={kriter}
                selKriterler={selKriterler}
                zorunlu={kriter.zorunlu}
                onChange={handleSelectionChange}
            />
        }

        return <div key={kriter.kriterModul.id}>{kriter.kriterModul.valueType}{kriter.kriterModul.display}</div>;
    }

    return (
        <Container sx={{ pt: 2 }}>
            <HeaderText>{moduleName}</HeaderText>
            {kriterler.map((kriter) => {
                return <>{renderComponent(kriter)}</>

            })}
        </Container >
    );
};

export default KriterModulBilesenlerComponent;

